/* eslint-disable jira/filename-case */
import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages';

export function AutomationGraphic() {
	const { formatMessage } = useIntl();
	return (
		<svg
			width="366"
			height="276"
			viewBox="0 0 366 276"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				width="200"
				height="244"
				transform="matrix(0.997242 -0.0742187 0.0655601 0.997849 0 15.8682)"
				fill="#1868DB"
			/>
			<rect
				x="172.24"
				y="13.9958"
				width="193"
				height="243"
				transform="rotate(1.512 172.24 13.9958)"
				fill="#FCA700"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M200.349 14.738L215.445 244.499L166.059 248.175L172.24 13.9961L200.349 14.738Z"
				fill="#09326C"
			/>
			<rect width="284" height="185" transform="translate(41 40)" fill="white" />
			<rect width="284" height="56" transform="translate(41 40)" fill="white" />
			<g clip-path="url(#clip0_1210_18323)">
				<g clip-path="url(#clip1_1210_18323)">
					<g clip-path="url(#clip2_1210_18323)">
						<g clip-path="url(#clip3_1210_18323)">
							<path
								d="M67.2752 72.3371H65.6108C63.1006 72.3371 61.2998 70.7996 61.2998 68.5482H70.2492C70.7131 68.5482 71.0132 68.8777 71.0132 69.3444V78.35C68.7758 78.35 67.2752 76.5379 67.2752 74.012V72.3371ZM71.6953 67.8618H70.0309C67.5207 67.8618 65.7199 66.3517 65.7199 64.1003H74.6694C75.1332 64.1003 75.4606 64.4023 75.4606 64.8691V73.8747C73.2233 73.8747 71.6953 72.0626 71.6953 69.5366V67.8618ZM76.1427 63.4139H74.4784C71.9682 63.4139 70.1674 61.8764 70.1674 59.625H79.1168C79.5806 59.625 79.8808 59.9545 79.8808 60.3938V69.3993C77.6434 69.3993 76.1427 67.5872 76.1427 65.0613V63.4139Z"
								fill="#1868DB"
							/>
						</g>
					</g>
				</g>
				<text
					fill="#172B4D"
					xmlSpace="preserve"
					// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
					style={{ whiteSpace: 'pre' }}
					fontSize="16"
					fontWeight="590"
					letterSpacing="0px"
				>
					<tspan x="91" y="73.6875">
						{formatMessage(messages.automationSvgText)}
					</tspan>
				</text>
			</g>
			<line x1="88.5" y1="127" x2="88.5" y2="175" stroke="#626F86" />
			<rect x="61.5" y="95.5" width="236" height="31" rx="9.5" fill="white" />
			<rect x="61.5" y="95.5" width="236" height="31" rx="9.5" stroke="#DCDFE4" />
			<text
				fill="#626F86"
				xmlSpace="preserve"
				// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
				style={{ whiteSpace: 'pre' }}
				font-family="SF Pro"
				font-size="12"
				font-weight="510"
				letter-spacing="0px"
			>
				<tspan x="91" y="115.266">
					When:{' '}
				</tspan>
			</text>
			<rect x="70" y="103" width="16" height="16" rx="3" fill="#BAF3DB" />
			<rect x="132" y="107" width="112" height="10" rx="3" fill="#DCDFE4" />
			<rect x="61.5" y="135.5" width="236" height="31" rx="9.5" fill="white" />
			<rect x="61.5" y="135.5" width="236" height="31" rx="9.5" stroke="#DCDFE4" />
			<text
				fill="#626F86"
				xmlSpace="preserve"
				// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
				style={{ whiteSpace: 'pre' }}
				font-family="SF Pro"
				font-size="12"
				font-weight="510"
				letter-spacing="0px"
			>
				<tspan x="91" y="155.266">
					Issue is:{' '}
				</tspan>
			</text>
			<rect x="70" y="143" width="16" height="16" rx="3" fill="#FFF7D6" />
			<rect x="145" y="146" width="69" height="10" rx="3" fill="#DCDFE4" />
			<rect x="61.5" y="175.5" width="236" height="31" rx="9.5" fill="white" />
			<rect x="61.5" y="175.5" width="236" height="31" rx="9.5" stroke="#DCDFE4" />
			<text
				fill="#626F86"
				xmlSpace="preserve"
				// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
				style={{ whiteSpace: 'pre' }}
				font-family="SF Pro"
				font-size="12"
				font-weight="510"
				letter-spacing="0px"
			>
				<tspan x="91" y="195.266">
					Then:{' '}
				</tspan>
			</text>
			<rect x="70" y="184" width="16" height="16" rx="3" fill="#CCE0FF" />
			<rect x="130" y="186" width="137" height="10" rx="3" fill="#DCDFE4" />
			<defs>
				<clipPath id="clip0_1210_18323">
					<rect width="236" height="24" fill="white" transform="translate(59 56)" />
				</clipPath>
				<clipPath id="clip1_1210_18323">
					<rect width="24" height="24" fill="white" transform="translate(59 56)" />
				</clipPath>
				<clipPath id="clip2_1210_18323">
					<rect width="24" height="24" fill="white" transform="translate(59 56)" />
				</clipPath>
				<clipPath id="clip3_1210_18323">
					<rect width="18.581" height="18.725" fill="white" transform="translate(61.2998 59.625)" />
				</clipPath>
			</defs>
		</svg>
	);
}
